import { resolveStoreByIp } from '@gozoki/api'
import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  redirect,
} from '@tanstack/react-router'
import { ErrorPage } from '~/pages/ErrorPage'
import { HomePage } from '~/pages/HomePage'
import { getToken, setToken } from '~/utils/api'

const rootRoute = createRootRoute({
  component: Outlet,
})

const errorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/error',
  component: ErrorPage,
})

// Route protégée : plus de login. Sans token, on résout la boutique via l'IP publique du device.
// IP reconnue → token boutique émis, dashboard affiché. IP inconnue → page d'erreur.
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: async () => {
    // Aperçu depuis le back-office : un token injecté en query prime. L'iframe BO est sur une autre
    // origine, le localStorage du kiosk lui est donc inaccessible — le token transite par l'URL.
    // On le persiste puis on le retire de l'URL pour ne pas le laisser dans l'historique.
    const url = new URL(window.location.href)
    const injected = url.searchParams.get('token')
    if (injected) {
      await setToken(injected)
      url.searchParams.delete('token')
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`)
      return
    }
    const token = await getToken()
    if (token) return
    try {
      const { token: issued } = await resolveStoreByIp()
      await setToken(issued)
    } catch {
      throw redirect({ to: '/error' })
    }
  },
  component: HomePage,
})

const routeTree = rootRoute.addChildren([indexRoute, errorRoute])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
